var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    "data-name": "Layer 1",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0074ff;}.cls-2{fill:#ffb300;}")), /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.79,56H14.9a2,2,0,0,1-2-2V51.57a2,2,0,1,1,4,0V52H38.79V20.31H16.9V42.25a2,2,0,1,1-4,0V18.31a2,2,0,0,1,2-2H40.79a2,2,0,0,1,2,2V54A2,2,0,0,1,40.79,56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M49.1,47.69H46.5a2,2,0,0,1,0-4h.6V12H25.21v.5a2,2,0,0,1-4,0V10a2,2,0,0,1,2-2H49.1a2,2,0,0,1,2,2V45.69A2,2,0,0,1,49.1,47.69Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/CopyIcon.c28e1f7bafe02ff6bfc9fc276b6cbad8.svg";
export { ForwardRef as ReactComponent };